<template>
  <div class="all">
    <div class="bommot">
      <ctar1 @closeDialog="g_area_list"></ctar1>
      <div style="width: 100%; height: 100%; float: left">
        <div style="width: 100%; height: 100%">
          <div style="
              position: absolute;
              z-index: 100;
              width: 15%;
              display: flex;
              left: 4%;
              top: 3%;
            ">
            <div style="width: 90%">
              <el-input v-model="input" placeholder="请输入车辆vin" id="tipinput"></el-input>
            </div>
            <div style="float: left" @click="lookup()">
              <el-button type="primary">
                <div class="el-icon-search"></div>
              </el-button>
            </div>
          </div>

          <div id="container2"></div>
        </div>
        <div v-show="showtab" style="
            width: 80%;
            height: 290px;
            position: absolute;
            bottom: 0%;
            left: 3.5%;
          ">
          <div class="bommot1">
            <div style="
                width: 33%;
                display: flex;
                justify-content: space-around;
                align-items: center;
              ">
              <span>监控：{{ all }}</span>
              <span>报警：{{ jing }}</span>
              <span>
                <img style="width: 30px;height: 30px;" src="../../assets/img/car_green.png"  />
              </span>
              <span>在线</span>
              <img style="width: 30px;height: 30px;" src="../../assets/img/car_orange.png" />
              <span>关注</span>
              <img style="width: 30px;height: 30px;" src="../../assets/img/car_gray.png" />
              <span>离线</span>
              <img style="width: 30px;height: 30px;" src="../../assets/img/car_red.png" />
              <span>报警</span>
            </div>
            <div style="width: 40%"></div>
            <!-- <div style="
                width: 20%;
                display: flex;
                justify-content: space-around;
                align-items: center;
              ">
              <span>设置</span>
              <span>刷新：5s</span>
              <span>
                <img src="../../assets/img/center_right_4.png" />
              </span>
              <span>
                <img src="../../assets/img/center_right_1.png" />
              </span>
              <span>
                <img src="../../assets/img/center_right_2.png" />
              </span>
              <span>
                <img src="../../assets/img/center_right_3.png" />
              </span>
            </div> -->
          </div>
          <el-table :data="tableData" height="86%" stripe>
            <el-table-column prop="car_number" width="100" label="车牌号"></el-table-column>
            <el-table-column label="车辆编号" width="300" align="center">
              <template #default="scope">
                <span @click="centers(scope.row)" style=" cursor : pointer">{{ scope.row.vin }}</span>
              </template>
            </el-table-column>

            <!-- 
            <el-table-column prop="vin" label="车辆编号" width="300" align="center" @click="centers(item)">
            </el-table-column> -->
            <el-table-column prop="type_name" width="150" label="车辆型号"></el-table-column>
            <el-table-column prop="scram_state" width="100" label="急停状态"></el-table-column>
            <el-table-column prop="speed" label="车速" width="100"></el-table-column>
            <el-table-column prop="mileage" label="总里程" width="100"></el-table-column>
            <el-table-column prop="gps_time" width="200" label="定位时间"></el-table-column>
            <el-table-column prop="address" label="最后定位"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
  <div class="right">
    <!-- <div class="right1"> -->
    <el-row>
      <el-col :span="18">
        <el-input v-model="filterText" placeholder="请输入组织名称" />
      </el-col>
      <el-col :span="4">
        <el-button type="primary">搜索</el-button>
      </el-col>
    </el-row>
    <div style="height: 83%">
      <el-scrollbar height="95%">
        <el-tree ref="treeRef" class="filter-tree" :data="tree_data" :props="defaultProps" node-key="value"
          :default-expanded-keys="launch" :filter-node-method="filterNode" @node-click="handleBucketClick"
          highlight-current></el-tree>
        <!-- </div> -->
        <div class="right2">
          <div style="
              width: 100%;
              height: 30px;
              background-color: #0063ae;
              display: flex;
                justify-content: flex-end;
              align-items: center;
            ">
            <RefreshRight color="blue" style="width: 2em; height: 2em; margin-right: 8px" @click="g_area_car_list()" />
          </div>
          <el-row v-for="(item, index) in car_list" :key="index">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <img :src="item.image" />
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content bg-purple-light" style=" cursor : pointer">{{ item.vin }}</div>
            </el-col>
            <el-col :span="6">
              <div @click="f_car(item)" class="grid-content bg-purple">
                <div v-if="item.is_focus == '1'">
                  <img src="../../assets/img/icon_gz.png" />
                </div>

                <div v-else>
                  <img src="../../assets/img/icon_qxgz.png" />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-scrollbar>
      <div style="width: 100px;">
        <div class="demo-pagination-block" style="margin-bottom: 20%">
          <el-pagination v-model:currentPage="currentPage3" :page-size="table_page.limit" :pager-count="5"
            layout="prev, pager, next" :total="table_page.sum" @current-change="handsize"></el-pagination>
        </div>
      </div>

      <div class="bommot2">
        <div :class="backcolor[index]" v-for="(item, index) in listdata" :key="index">
          <div class="center">{{ item.num }}</div>
          <div class="center">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>   
<script >
import ctar1 from "../../components/ctar1.vue";
import zuzhi from "../../components/zuzhi.vue";
import { useRouter } from "vue-router";
import {
  get_area_list,
  get_area_all_car_info,
  get_area_car_list,
  focus_car,
  get_all_car_status,
  get_area_all_car_info_list,
  get_area_one_car_info
} from "../../api/car_manage/car_manage";
import { RefreshRight } from "@element-plus/icons";
import { reactive, onMounted, toRefs, onBeforeUnmount, ref, watch } from "vue";
import { ElMessageBox, ElMessage } from 'element-plus'
let containerth = ""; //地图实例
let setInterval_arr = []
let sett = ''
let zuzhitime = ''
let a = []
let b = ''
export default {
  components: { ctar1, zuzhi, RefreshRight },
  name: "Car_manage",
  setup() {
    const router = useRouter();
    const data = reactive({
      input: "",
      value: "",
      value1: "",
      showtab: true,
      options: [
        {
          value: "15",
          label: "15条/页",
        },
        {
          value: "10",
          label: "10条/页",
        },
        {
          value: "5",
          label: "5条/页",
        },
      ],
      miao: "5",
      backcolor: ["child0", "child1", "child2", "child3", "child4"],
      ditu: "",
      car_list: "",
      table_page: {
        sum: 20,
        page: 1,
        limit: 10,
      },
      multipleSelection: [],
      listdata: "",
      area_id: "0",
      tableData: '',
      tree_data: [],
      all: "",
      jing: '',
      area_name: '',
      launch: []
    });
    const filterText = ref('')
    const treeRef = ref('')

    const defaultProps = {
      children: 'children',
      label: 'label',
    }
    watch(filterText, (val) => {
      treeRef.value.filter(val)
    })
    localStorage.setItem("selectTab_item", "Car_manage");
    //树节点过滤
    const filterNode = (value, data) => {
      if (!value) return true
      return data.label.includes(value)
    }
    //树节点的展开收缩

    //table信息
    const g_area_all_car_info_list = async () => {
      await get_area_all_car_info_list(data.area_id, data.table_page.page, data.table_page.limit).then((res) => {
        a = res.data
     
      })
    }
    const pp = (lnglat, type) => {
      return new Promise((resolve, reject) => {
        var geocoder = new AMap.Geocoder({
          city: "010", //城市设为北京，默认：“全国”
          radius: 1000 //范围，默认：500
        });
        AMap.convertFrom(lnglat, type, function (status, result) {
          if (result.info === "ok") {
            var resLnglat = result.locations[0];
            geocoder.getAddress(resLnglat, function (status, result) {
              if (status === 'complete' && result.regeocode) {
                var address = result.regeocode.formattedAddress;
                resolve(address)
              }
            });
          }
        });

      })

    }

    //获取并处理处理table 信息
    const get_carinfo_table = async () => {
      await g_area_all_car_info_list()
      for (let i in a) {
        let speed = a[i].speed
        if (speed && speed != 0) {
          a[i].speed = Number(speed).toFixed(1) + 'Km/h'
        } else {
          a[i].speed = "0" + 'Km/h'
        }
        let mileage = a[i].mileage
        if (mileage && Number(mileage) != 0) {
          //  mileage = Number(mileage) / 10000
          a[i].mileage = Number(mileage).toFixed(2) + '公里'
        } else {
          a[i].mileage = 0 + '公里'
        }
        if (a[i].gps[0].lng != 0) {
          let lnglat = [
            a[i].gps[0].lng,
            a[i].gps[0].lat,
          ];
          await pp(lnglat, 'gps').then(res => { a[i].address = res  })
        }
      }
      data.tableData = a
    }
    //组织内的车辆列表
    const g_area_car_list = () => {

      get_area_car_list(
        data.table_page.page,
        data.table_page.limit,
        data.area_id
      ).then((res) => {
        data.car_list = res.data;
        data.table_page.sum = res.count;
      });
    };
    //关注
    const f_car = (row) => {
      let vin = row.vin;
      let focus = row.is_focus == 0 ? 1 : 0;
      focus_car(vin, focus).then((res) => {
        g_area_car_list();
        g_all_car_status();
      });
    };
    //点击table 地图变化
    const centers = (val) => {
      if (val.gps[0].lng != 0) {
        let path = [val.gps[0].lng, val.gps[0].lat]
        AMap.convertFrom(path, val.gps[0].type, function (status, result) {
          if (result.info === "ok") {
            var resLnglat = result.locations[0];
            containerth.setZoomAndCenter(18, [result.locations[0].lng, result.locations[0].lat]); //同时设置地图层级与中心点
            // 创建纯文本标记
          }
        });
      } else {
        ElMessage({
          message: '当前车辆没有定位',
          type: 'warning',
        })
      }
    }

    //点击切换 组织 获取组织内车辆
    const handleBucketClick = async (e) => {

      a = []
      if (data.launch.indexOf(e.value) > -1) {
        data.launch.splice(data.launch.indexOf(e.value), 1) // 存在就删除
      } else {
        data.launch.push(e.value)
      }
      data.table_page.page = 1
      if (e.value != undefined) {
        data.area_id = e.value
        //渲染地图
        g_area_all_car_info()
        //车辆列表
        g_area_car_list()
        //table
        get_carinfo_table()
      }
    }
    // 组织列表
    const g_area_list = async () => {
      get_area_list(data.area_name).then((res) => {
        data.tree_data = [];
        data.tree_data.push(res.data);
        // if (res.data.children.length != 0) {
        //   data.area_id = res.data.children[0].value
        // }
        //组织内的车辆列表
        g_area_car_list();
        // 地图坐标区域渲染
        //   g_area_all_car_info();
        //table信息
        // g_area_all_car_info_list()
        get_carinfo_table()
      });
    };

    // 地图坐标区域渲染
    const g_area_all_car_info = () => {
      containerth.clearMap();
      let _tmp;
      while (_tmp = setInterval_arr.pop()) {
        clearInterval(_tmp);
      }
      if (sett) {
        clearTimeout(sett)
      }
      sett = setTimeout(() => {
        containerth.setFitView(null, true, [150, 360, 200, 400]);
      }, 3000);
      get_area_all_car_info(data.area_id, data.table_page.page, data.table_page.limit).then((res) => {

        for (let i in res.data) {
          if (res.data[i].car_gps.length != 0) {
            let marker4 = ''
            let xpath4 = []
            let polyline4 = ''
            setInterval_arr.push(setInterval(() => {
              get_area_one_car_info(i).then((req) => {
                if (req.data[0].car_gps.length != 0) {
                  if (req.data[0].car_gps[0].longitude != 0 && req.data[0].car_gps[0].latitude != 0) {
                    let lnglat = [
                      req.data[0].car_gps[0].longitude,
                      req.data[0].car_gps[0].latitude];
                    let icon = req.data[0].car_status_img;
                    let type = req.data[0].gps_type;
                    let course = req.data[0].car_gps[0].course;
                    var startIcon = new AMap.Icon({
                      image: icon,
                      // 图标所用图片大小
                      imageSize: new AMap.Size(25, 30),
                    });
                    AMap.convertFrom(lnglat, type, function (status, result) {
                      if (result.info === "ok") {
                        var resLnglat = result.locations[0];
                        var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
                        if (req.data[0].car_status == 1) {
                          if (marker4) {
                            marker4.setIcon(startIcon)
                            marker4.setAngle(course);
                            marker4.setPosition([
                              result.locations[0].lng,
                              result.locations[0].lat,
                            ]);
                          } else {
                            marker4 = new AMap.Marker({
                              icon: startIcon,
                              position: [result.locations[0].lng, result.locations[0].lat],
                              offset: new AMap.Pixel(-13, -30),
                              angle: course,
                            });
                          }
                          marker4.setMap(containerth);
                          marker4.on('click', markerClick);
                          function markerClick(e) {
                            infoWindow.setContent(i);
                            infoWindow.open(containerth, e.target.getPosition());
                          }
                          let zlnglat = [result.locations[0].lng, result.locations[0].lat]
                          xpath4.push(zlnglat);
                          let paths = xpath4.map((d) => {
                            return new AMap.LngLat(d[0], d[1]);
                          });
                          if (polyline4) {
                            //判断清空上一次的轨迹
                            containerth.remove(polyline4);
                          }
                          polyline4 = new AMap.Polyline({
                            path: paths,
                            borderWeight: 2, // 线条宽度，默认为 1
                            strokeColor: "#3366FF", // 线条颜色
                            lineJoin: "round", // 折线拐点连接处样式
                          });
                          containerth.add(polyline4);
                        } else {
                          if (marker4) {
                            marker4.setIcon(startIcon)
                          } else {
                            marker4 = new AMap.Marker({
                              icon: startIcon,
                              position: [result.locations[0].lng, result.locations[0].lat],
                              offset: new AMap.Pixel(-13, -30),
                              angle: course,
                            });
                            marker4.setMap(containerth);
                            marker4.on('click', markerClick);
                            function markerClick(e) {
                              infoWindow.setContent(i);
                              infoWindow.open(containerth, e.target.getPosition());
                            }
                          }
                        }

                      }
                    });
                  }


                }

              })
            }, 1000))

          }
        }

      });

    };
    // 地图坐标区域渲染
    // const g_area_all_car_info = async () => {
    //   await get_area_all_car_info(data.area_id, data.table_page.page, data.table_page.limit).then((res) => {
    //     for (let i in res.data) {
    //       if (res.data[i].car_gps.length != 0) {
    //         let marker4 = ''
    //         let xpath4 = []
    //         let polyline4 = ''
    //         setInterval_arr.push(setInterval(() => {
    //           get_area_one_car_info(i).then((req) => {
    //             if (req.data[0].car_gps.length != 0) {
    //               if (req.data[0].car_gps[0].longitude != 0 && req.data[0].car_gps[0].latitude != 0) {
    //                 let lnglat = [
    //                   req.data[0].car_gps[0].longitude,
    //                   req.data[0].car_gps[0].latitude];
    //                 let icon = req.data[0].car_status_img;
    //                 let type = req.data[0].gps_type;
    //                 let course = req.data[0].car_gps[0].course;
    //                 var startIcon = new AMap.Icon({
    //                   image: icon,
    //                   // 图标所用图片大小
    //                   imageSize: new AMap.Size(25, 30),
    //                 });
    //                 AMap.convertFrom(lnglat, type, function (status, result) {
    //                   if (result.info === "ok") {
    //                     var resLnglat = result.locations[0];
    //                     var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
    //                     if (req.data[0].car_status == 1) {
    //                       if (marker4) {
    //                         marker4.setAngle(course);
    //                         marker4.setPosition([
    //                           result.locations[0].lng,
    //                           result.locations[0].lat,
    //                         ]);
    //                       } else {
    //                         marker4 = new AMap.Marker({
    //                           icon: startIcon,
    //                           position: [result.locations[0].lng, result.locations[0].lat],
    //                           offset: new AMap.Pixel(-13, -30),
    //                           angle: course,
    //                         });
    //                       }
    //                       marker4.setMap(containerth);
    //                       marker4.on('click', markerClick);
    //                       function markerClick(e) {
    //                         infoWindow.setContent(i);
    //                         infoWindow.open(containerth, e.target.getPosition());
    //                       }
    //                       let zlnglat = [result.locations[0].lng, result.locations[0].lat]
    //                       xpath4.push(zlnglat);
    //                       let paths = xpath4.map((d) => {
    //                         return new AMap.LngLat(d[0], d[1]);
    //                       });
    //                       if (polyline4) {
    //                         //判断清空上一次的轨迹
    //                         containerth.remove(polyline4);
    //                       }
    //                       polyline4 = new AMap.Polyline({
    //                         path: paths,
    //                         borderWeight: 2, // 线条宽度，默认为 1
    //                         strokeColor: "#3366FF", // 线条颜色
    //                         lineJoin: "round", // 折线拐点连接处样式
    //                       });
    //                       containerth.add(polyline4);
    //                     } else {
    //                       // marker4 = new AMap.Marker({
    //                       //   icon: startIcon,
    //                       //   position: [result.locations[0].lng, result.locations[0].lat],
    //                       //   offset: new AMap.Pixel(-13, -30),
    //                       //   angle: course,
    //                       // });
    //                       // marker4.setMap(containerth);
    //                       // marker4.on('click', markerClick);
    //                       // function markerClick(e) {
    //                       //   infoWindow.setContent(i);
    //                       //   infoWindow.open(containerth, e.target.getPosition());
    //                       // }
    //                       if (marker4) {
    //                         // marker4.setAngle(course);
    //                         // marker4.setIcon(startIcon)
    //                         // marker4.setPosition([
    //                         //   result.locations[0].lng,
    //                         //   result.locations[0].lat,
    //                         // ]);
    //                       } else {
    //                         marker4 = new AMap.Marker({
    //                           icon: startIcon,
    //                           position: [result.locations[0].lng, result.locations[0].lat],
    //                           offset: new AMap.Pixel(-13, -30),
    //                           angle: course,
    //                         });
    //                         marker4.setMap(containerth);
    //                         marker4.on('click', markerClick);
    //                         function markerClick(e) {
    //                           infoWindow.setContent(i);
    //                           infoWindow.open(containerth, e.target.getPosition());
    //                         }
    //                       }
    //                     }

    //                   }
    //                 });
    //               }


    //             }

    //           })
    //         }, 1000))

    //       }
    //     }

    //   });

    // };

    //车辆状态
    const g_all_car_status = () => {
      get_all_car_status().then((res) => {
        data.listdata = res.data;

        data.all = data.listdata[0].num
        data.jing = data.listdata[4].num
      });
    };
    //查找车辆
    const lookup = () => {
      //查找单车数据
      get_area_one_car_info(data.input).then((res) => {
        if (res.code == 0) {
          if (res.data.length != 0) {
            ElMessageBox.alert('查询成功', '系统提示', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              // callback: (action) => {
              //   router.push({ name: "Bicycle_manage", query: { vin: data.input } })
              // },
            }).then(() => {
              router.push({ name: "Bicycle_manage", query: { vin: data.input } })

            })
              .catch(() => {
              })
          } else {
            ElMessageBox.alert('车辆VIN不存在', '系统提示', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              // callback: (action) => {
              //   router.push({ name: "Bicycle_manage", query: { vin: data.input } })
              // },
            }).then(() => {

            })
              .catch(() => {
              })
          }
        }



      })
    }

    //切换分页
    const handsize = (val) => {
      data.table_page.page = val;
      g_area_car_list();
      g_area_all_car_info_list()
      g_area_all_car_info()
    };
    // zuzhitime = setInterval(() => {
    //   g_area_list()
    //   g_all_car_status();
    //   // get_area_list(data.area_name).then((res) => {
    //   //   data.tree_data = [];
    //   //   data.tree_data.push(res.data);
    //   // });
    // }, 3000)
    //刷新组织列表
    // g_area_list();
    // g_all_car_status();
    // g_area_all_car_info();
    onMounted(() => {
      //加载地图
      containerth = new AMap.Map("container2", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        mapStyle: "amap://styles/normal",
        center: [118.017482, 36.803601],
        zoom: "9",
      });
     // g_area_all_car_info();
    });

    onBeforeUnmount(() => {
      //销毁地图
      containerth.destroy();
      let _tmp;
      if (sett) {
        clearTimeout(sett)
      }
      if (zuzhitime) {
        clearInterval(zuzhitime)
      }
      while (_tmp = setInterval_arr.pop()) {
        clearInterval(_tmp);
      }
    });
    return {
      ...toRefs(data),
      handleBucketClick,
      filterNode,
      f_car,
      handsize,
      centers,
      g_area_list,
      lookup,
      g_area_list,
      filterText,
      g_area_car_list,
      treeRef,
      defaultProps,
    };
  },
};
</script>
<style lang="scss" scoped>
.all {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/img/back.png");
  background-size: 100% 100%;
  position: relative;
}

.top_set {
  background-image: url("../../assets/img/top_set.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.bommot {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;

  display: flex;
}

.el-menu {
  border: rgb(255, 255, 255);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.rtar {
  height: 50%;
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top_screen {
  background-image: url("../../assets/img/top_screen.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_choose {
  background-image: url("../../assets/img/top_choose.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_dit {
  background-image: url("../../assets/img/top_dit.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_weix {
  background-image: url("../../assets/img/top_weix.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_cej {
  background-image: url("../../assets/img/top_cej.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_luk {
  background-image: url("../../assets/img/top_luk.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_kongq {
  background-image: url("../../assets/img/top_kongq.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_zuida {
  background-image: url("../../assets/img/top_zuida.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.top_xiaox {
  background-image: url("../../assets/img/top_xiaox.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

#container2 {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

/deep/.amap-copyright {
  font-size: 0px;
}

/deep/.amap-logo img {
  height: 0px !important;
  width: 0px !important;
}

.el-row {
  color: #000;
  text-align: center;
  margin-top: 5px;
}

.bommot1 {
  background-color: #0063ae;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.right {
  width: 15%;
  height: 90%;
  position: absolute;
  background-color: rgb(255, 255, 255);
  right: 1%;
  top: 10%;
  z-index: 999;

  .right2 {
    height: 80%;
    font-size: 12px;
  }
}

.input {
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  width: 40px;
  height: 30px;
  font-size: 14px;
}

.sel {
  border-radius: 3px;
  height: 30px;
  font-size: 12px;
  width: 180px;
  color: #000;
  background-color: rgb(255, 255, 255);
}

.bommot2 {
  height: 8%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  bottom: 0%;
  z-index: 99;
  font-size: 13px;

  .child0 {
    height: 90%;
    width: 17%;
    background-color: #bae7ff;
    border-radius: 5px;
  }

  .child2 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #d9f7be;
  }

  .child3 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #eeeeee;
  }

  .child4 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #ffcdcd;
  }

  .child1 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #ffe7ba;
  }
}

.center {
  display: flex;
  height: 50%;
  align-items: center;
  justify-content: center;
  color: #000;
}

/deep/ .amap-info-content {

  color: black !important;
}
</style>